import React from 'react';
import { BaseAlert, BaseAlertProps } from '../BaseAlert';
import { colors } from '../../../settings';
import styled from 'styled-components';
import { IconError } from '@99designs/icons';

export const StyledErrorAlert = styled(BaseAlert)`
    background: ${colors.semantic.error};
    color: white;
`;

type ErrorAlertProps = Omit<BaseAlertProps, 'icon'>;

export function ErrorAlert({ children, ...rest }: ErrorAlertProps) {
    return (
        <StyledErrorAlert icon={<IconError />} {...rest}>
            {children}
        </StyledErrorAlert>
    );
}
